import { submitSberPayUseCase } from "./submitSberPay.case";
import { processOfferVarsAndText } from "./utils";
import { EPaymentMethod } from "../../../../../../../../dependencies/getContent/constants";
import { findFirst } from "../../../../../../../../../utils/arrays";
import { INPUT_LENGTH } from "../../../../../../../../../constants";
// dependency injected factory function for sberpay button props
export var getMapStateToSberPayButtonProps = function getMapStateToSberPayButtonProps(_ref) {
  var getContent = _ref.getContent,
    submitSberPayPayment = _ref.submitSberPayPayment,
    refreshCaptcha = _ref.refreshCaptcha;
  return function (getState, setState) {
    var _state$scenario, _findFirst, _state$scenario$phone, _state$scenario$phone2;
    var state = getState();
    if (((_state$scenario = state.scenario) === null || _state$scenario === void 0 ? void 0 : _state$scenario.type) !== EPaymentMethod.SberPay) throw new Error('not sberpay screen');
    var content = getContent();
    var agreementText = processOfferVarsAndText(content);
    return {
      agreementText: agreementText,
      children: (_findFirst = findFirst([state.scenario.step === 1 && content.sberPayPopup.captcha.buttonText, content.sberPayPopup.buttonText])) !== null && _findFirst !== void 0 ? _findFirst : '',
      disabled: !!((_state$scenario$phone = state.scenario.phoneInput) !== null && _state$scenario$phone !== void 0 && _state$scenario$phone.errorMessage) || !((_state$scenario$phone2 = state.scenario.phoneInput) !== null && _state$scenario$phone2 !== void 0 && _state$scenario$phone2.value) || state.scenario.phoneInput.value.length < INPUT_LENGTH || !!state.scenario.phoneInput.isLoading || !!state.scenario.isLoading,
      onClick: function onClick() {
        submitSberPayUseCase({
          submitSberPayPayment: submitSberPayPayment,
          getContent: getContent,
          refreshCaptcha: refreshCaptcha
        })(getState, setState).catch(console.error);
      }
    };
  };
};